import { CONSUMPTION_TAX_RATE } from '../../define/consts/tax';
/**
 * 消費税の計算（内税）
 * @deprecated TS化済 src/utils/calc/tax.ts
 * @param value
 * @returns {number}
 */
export const calcIncludingTax = (value) => Math.floor(parseInt(value, 10) * (1 + CONSUMPTION_TAX_RATE));
export default calcIncludingTax;
